/** @jsx jsx */
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const CanClubHeroSection = ({ cta, description, images, title }) => {
  return (
    <Box
      bg="backgroundBright"
      sx={{ overflow: 'hidden', position: 'relative' }}
    >
      <Container pt={[0, 9, 12]} pb={[6, 10, 13]}>
        {images && (
          <Box
            sx={{
              bottom: [null, '0'],
              height: ['300px', '460px', '490px'],
              left: '50%',
              overflow: 'hidden',
              pointerEvents: 'none',
              position: ['relative', 'absolute'],
              transform: 'translateX(-50%)',
              width: ['640px', '832px', '1024px', '1240px'],
              '@media only screen and (min-width: 1240px)': {
                height: 'auto',
                width: '100vw',
              },
            }}
          >
            {
              <GatsbyImage
                image={withArtDirection(getImage(images[0]), [
                  {
                    image: getImage(images[3]),
                    media: `(min-width: 1024px)`,
                  },
                  {
                    image: getImage(images[2]),
                    media: `(min-width: 832px)`,
                  },
                  {
                    image: getImage(images[1]),
                    media: `(min-width: 640px)`,
                  },
                  {
                    image: getImage(images[0]),
                    media: `(min-width: 0px)`,
                  },
                ])}
                alt={images[0].description}
                loading={'eager'}
                style={{ height: '100%', width: 'auto' }}
              />
            }
          </Box>
        )}
        <Grid
          columns={[1, 12]}
          mt={[3, 0]}
          sx={{ rowGap: '0', textAlign: 'center' }}
        >
          <Box sx={{ gridColumn: [null, '2 / 12', '3 / 11'] }}>
            <Heading as="h1" mb={[2, 3]} variant="title1">
              {title}
            </Heading>
          </Box>
          <Box
            px={[0, 5, null, 0]}
            sx={{ gridColumn: [null, '3 / 11', null, '4 / 10'] }}
          >
            <Box
              mb={4}
              variant="text.body1"
              sx={{ p: { m: 0 } }}
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
            />
            {cta}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default CanClubHeroSection
